import React, { forwardRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { usePaymentContext } from 'src/components/ClientProfile/Payment/PaymentProvider';

import DepositAmountChip from './DepositAmountChip';

const MULTIPLIER = 100;

const DepositAmountsBlock = forwardRef(({ defaultDepositAmount, depositAmounts = [] }, ref) => {
  const { search } = useLocation();
  const queryAmount = new URLSearchParams(search).get('amount');
  const { maxAmount, minAmount } = usePaymentContext();

  useEffect(() => {
    const defaultDeposit = depositAmounts.find(amount => amount.isDefault);
    if (!queryAmount && !defaultDepositAmount) return;

    let finalAmount = queryAmount ? Number(queryAmount) : defaultDeposit.value * MULTIPLIER;

    if (minAmount !== undefined) finalAmount = Math.max(finalAmount, minAmount);
    if (maxAmount !== undefined) finalAmount = Math.min(finalAmount, maxAmount);

    ref.current.setFieldValueHandler('amount', finalAmount);
  }, [defaultDepositAmount, depositAmounts, minAmount, maxAmount, queryAmount, ref]);

  if (depositAmounts.length === 0) return null;

  return (
    <div className="deposit-amounts">
      {depositAmounts.map(({ value }) => (
        <DepositAmountChip amount={value} key={value} ref={ref} />
      ))}
    </div>
  );
});

DepositAmountsBlock.propTypes = {
  defaultDepositAmount: PropTypes.shape({
    depositAmounts: PropTypes.arrayOf(PropTypes.object),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  depositAmounts: PropTypes.arrayOf(PropTypes.object),
};

export default DepositAmountsBlock;
